
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Loader2 } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { ContactFormValues } from "@/hooks/useContactForm";

interface ContactFormFieldsProps {
  form: UseFormReturn<ContactFormValues>;
  isSubmitting: boolean;
  onSubmit: (data: ContactFormValues) => Promise<void>;
}

const ContactFormFields = ({ form, isSubmitting, onSubmit }: ContactFormFieldsProps) => {
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6 p-6 bg-kaija-sage/30 rounded-lg">
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-kaija-slate font-medium">Nimi *</FormLabel>
              <FormControl>
                <Input placeholder="Sinu nimi" {...field} className="bg-white shadow-sm" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-kaija-slate font-medium">Email *</FormLabel>
              <FormControl>
                <Input placeholder="sinu.email@näide.ee" {...field} className="bg-white shadow-sm" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        {/* Honeypot field - invisible to humans but bots will fill it */}
        <div className="hidden" aria-hidden="true">
          <FormField
            control={form.control}
            name="website"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Website</FormLabel>
                <FormControl>
                  <Input 
                    tabIndex={-1} 
                    autoComplete="off"
                    {...field} 
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>
        
        <FormField
          control={form.control}
          name="message"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-kaija-slate font-medium">Kommentaar või sõnum</FormLabel>
              <FormControl>
                <Textarea 
                  placeholder="Kirjuta oma sõnum siia..." 
                  className="min-h-32 bg-white shadow-sm" 
                  {...field} 
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <Button 
          type="submit" 
          className="w-full bg-kaija-accent hover:bg-opacity-90 text-white"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <Loader2 className="h-4 w-4 animate-spin mr-2" /> 
              Saadan...
            </>
          ) : "Saada"}
        </Button>
      </form>
    </Form>
  );
};

export default ContactFormFields;
